import { useDashboardContext } from '@/common/dashboard/DashboardContext';
import { Grid } from '@/common/grid/Grid';
import { useDependentKey } from '@/common/hooks/key/useDependentKey';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { useEffect, useRef, useState } from 'react';

export const ChbkFinTrendTable = ({ totalValues, ctrtTypeIdToCtrtType, byYear, dim }) => {
  const { formValues } = useDashboardContext();
  let { dateBasis, monthPeriodId, qtrPeriodId, date, periodicity, distCustIds, ctrtTypeIds, prodIds, agg } = formValues;

  const { totalProdIds, totalDistCustIds } = totalValues;

  const gridRef = useRef();

  const rsrc = useRsrc();

  const [data, setData] = useState();

  const [fieldDefs, setFieldDefs] = useState();
  const [isGridReady, setIsGridReady] = useState(false);

  useEffect(() => {
    setIsGridReady(false);
    const periodId = periodicity === 'MONTH' ? monthPeriodId : periodicity === 'QUARTER' ? qtrPeriodId : null;
    const reqParam = {
        periodId,
        date,
        byYear,
        agg
    };

    rsrc.data('sc', 'CHBK_FIN_TREND_TABLE_FIELD_DEFS_DATA_PLUGIN', reqParam).then(fieldDefs => {
      setFieldDefs(fieldDefs);
    });
  }, [monthPeriodId, qtrPeriodId, date, periodicity, byYear, agg]);

  useEffect(() => {
    const periodId = periodicity === 'MONTH' ? monthPeriodId : periodicity === 'QUARTER' ? qtrPeriodId : null;
    if (!periodId && !date) {
      return;
    }

    let prodIdsNot = true;
    if (totalProdIds.length / 2 < prodIds.length) {
      prodIds = totalProdIds.filter(id => !prodIds.includes(id));
    } else {
      prodIdsNot = false;
    }

    let distCustIdsNot = true;
    if (totalDistCustIds.length / 2 < distCustIds.length) {
      distCustIds = totalDistCustIds.filter(id => !distCustIds.includes(id));
    } else {
      distCustIdsNot = false;
    }

    const reqParam = {
      dateBasis,
      periodId,
      date,
      periodicity,
      distCustIds,
      distCustIdsNot,
      ctrtTypes: ctrtTypeIds.map(id => ctrtTypeIdToCtrtType[id]),
      prodIds,
      prodIdsNot,
      byYear,
      agg,
      dim
    };

    rsrc.data('sc', 'CHBK_FIN_TREND_TABLE_DATA_PLUGIN', reqParam).then(res => {
      setData(res);
    });

  }, [dateBasis, monthPeriodId, qtrPeriodId, date, periodicity, distCustIds, ctrtTypeIds, prodIds, byYear, agg, dim]);

  const onGridReady = () => {
    setIsGridReady(true);
  };

  useEffect(() => {
    if (isGridReady && gridRef.current && data) {
        gridRef.current.setDataSource(data.rows);
        gridRef.current.setTotalsRow(data.totalsRow);
    }
  }, [isGridReady, data]);

  const gridKey = useDependentKey(fieldDefs);

  if (!data) {
    return null;
  }

  return (
    <>
        <Grid
            key={gridKey}
            ref={gridRef}
            gridOptions={{
            fieldDefs,
            rowModelType: 'clientSide',
            statusBar: null
            }}
            events={{ onGridReady }}
        />
    </>

  );
};
